import { render, staticRenderFns } from "./extrasSetting.vue?vue&type=template&id=bbf5b2e6&"
import script from "./extrasSetting.vue?vue&type=script&lang=js&"
export * from "./extrasSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports